<div class="modal-header">
  <h4 class="modal-title">
    {{title}}
  </h4>
  <a class ='clickable' aria-label="Close" (click)="closeModal(false)">
    <i class ='fas fa-times'></i>
  </a>
</div>

<div class="modal-body">
  <div class='row'>
    <div class='col'>
      <p>{{message}}</p>
    </div>
  </div>
</div>

<div class="modal-footer">
  <div class='col'>

    <div class='row'>
      <div class='col-2'>
        <button class='btn btn-success' type ='button' (click)="closeModal(true)">
          {{confirmationMessage}}
        </button>
      </div>

      <div class ='col-8'>

      </div>

      <div class='col-2'>
        <button class='btn btn-light' type ='button' (click)="closeModal(false)">
          {{declineMessage}}
        </button>
      </div>

    </div>
  </div>

</div>